module.exports = __webpack_public_path__ + "img/college-1-min.e71fe3fd.png";